class blogFilter extends HTMLElement {
    constructor() {
        super();
        this.innerContent = this.querySelector('.hb_main-blog-filter-inner');
        this.mainBlogHeader = document.querySelector("[js-main-blog-header]");
        this.mainBlog = document.querySelector("[js-hb-main-blog]");
        this.scrollToElement = document.querySelector("[js-filter-loading]");
        
        this.init();
    }
    getSectionsToRender() {
        return [
            {
                selector: "js-main-blog-header",
                sectionId: this.mainBlogHeader?.dataset?.section || "Header not found"
            },
            {
                selector: "js-hb-main-blog",
                sectionId: this.mainBlog?.dataset?.section || "Main blog not found"
            },
        ];
    }
    
    init() {
        this.filterItems = this.querySelectorAll("[js-filter-item]");
        this.filterItems.forEach(filterItem => {
            filterItem.addEventListener('click', (e) => {
                this.filterItems.forEach(item => item.classList.remove('active'));
                e.preventDefault();
                e.currentTarget.classList.add('active');
                const isParentMatch = e.currentTarget.closest("[js-current-tag-list]") ? false : true;
                this.initAjaxBlog(e.currentTarget,isParentMatch);
            });
        });
    }

    initAjaxBlog(target,isParentMatch) {
        const tagUrl = target.querySelector("a").getAttribute("href");
        this.updateLoading(true);
        this.updateHistoryState(tagUrl);
        this.renderAjaxBlog(tagUrl, isParentMatch);
    }
    
    updateLoading(loading) {
        if(loading) {
            this.mainBlogHeader.classList.add('disabled');
            this.scrollToElement.classList.add('loading');
        }else {
            this.mainBlogHeader.classList.remove('disabled');
            this.scrollToElement.classList.remove('loading');
        }
    };

    updateHistoryState(TagUrl) {
        var newurl = `${window.location.protocol}//${window.location.host}${TagUrl}`;
        window.history.replaceState({ path: newurl }, '', newurl);
    }

    renderAjaxBlog(tagUrl,isParentMatch) {
        this.getSectionsToRender().forEach(section => {
            const url = `${tagUrl}?section_id=${section.sectionId}`;
    
            fetch(url)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newContent = doc.querySelector(`[${section.selector}]`);
    
                    if (newContent) {
                        const filterDrawer = newContent.querySelector('[js-blog-filter-drawer]');
                        // if (isParentMatch && filterDrawer) {
                        //     filterDrawer.classList.add('open');
                        // }
                        if (section.selector === "js-main-blog-header" && this.mainBlogHeader) {
                            this.mainBlogHeader.innerHTML = newContent.innerHTML;
                        } else if (section.selector === "js-hb-main-blog" && this.mainBlog) {
                            this.mainBlog.innerHTML = newContent.innerHTML;
                        }
                    }
                    this.updateLoading(false);
                    document.dispatchEvent(new CustomEvent("filter-drawer:init"));
    
                })
                .catch(error => {
                    console.error('Error fetching blog content:', error);
                });
        });
    }
    
}

customElements.define('blog-filter', blogFilter);
